/* eslint-disable @typescript-eslint/dot-notation */
// @ts-nocheck

import type { RefObject, FC } from 'react';
import { useAppConfig } from "@hmpu/powerups.config.app.provider";
import type { ListItemPropsOptions, ListItemVariantProps } from './OptionsMenuListItem';

export type OptionsMenuListItems = ListItemVariantProps<any>[];

export type SettingsConfig = {
  root: {
    name: string;
    heading: string;
    component: FC<any>;
    items: OptionsMenuListItems,
    options: Partial<ListItemPropsOptions>
  },
}

export const processLocaleKeys = (data, options) => {
  const translatedEntries = Object.entries(data)
    .map(([attr, value]) => {
      if(typeof value !== 'undefined' && typeof value['localeKey'] === 'string') {
        return [attr, options.__t(value['localeKey'], value['ns'])]
      } 
        return [attr, value];
      
    });
  return Object.fromEntries(translatedEntries);
}

export const parseSettingsConfig = (config: SettingsConfig, additionalOptions): SettingsConfig => {
  config.root.options = {...config.root.options, ...additionalOptions}
  config.root = processLocaleKeys(config.root, config.root.options);
  config.root.items = config.root.items.map((itemData: ListItemVariantProps<any>) => {
    return {
      ...{
        shouldRender: () => true,
        ...itemData,
        ...processLocaleKeys(itemData, config.root.options)
      }
    }
  });
  return config;
};

export function useSettingsConfig(options: ListItemPropsOptions):SettingsConfig {
  const appConfig = useAppConfig();
  const configRef:RefObject<SettingsConfig> = { current: parseSettingsConfig(appConfig.components.SettingsPanel, options)};
  return configRef.current!;
}

export default useSettingsConfig;